module.exports = __webpack_public_path__ + "static/media/batch-icon.5941f475.svg";